import { IonSpinner, IonBackdrop } from '@ionic/react';
import './LoadingOverlay.css';

interface LoadingOverlayProps {
  show: boolean;
  message?: string;
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ show, message = 'Loading...' }) => {
  if (!show) return null;

  return (
    <>
      <IonBackdrop visible={show} tappable={false} />
      <div className="loading-overlay">
        <div className="loading-content">
          <div className="loading-spinner-container">
            <IonSpinner name="crescent" className="loading-spinner" />
            <div className="spinner-ring"></div>
          </div>
          <p className="loading-message">{message}</p>
        </div>
      </div>
    </>
  );
};

export default LoadingOverlay;

